import Big from 'big.js'
import { toNumber, toString } from 'lodash-es'

const displayPrice = (
  number: string | number,
  prefix: string = '',
  fixed: number = 2,
  noRounding?: boolean
) => {
  const normalized = toString(number).replace(',', '')
  // Checking if number is numeric
  if (isNumeric(normalized)) {
    const roundedNumber = !noRounding
      ? Big(normalized)
          .round(fixed || 2, Big.roundHalfEven)
          .toString()
      : normalized

    const fixedNumber =
      fixed && fixed > 0
        ? Big(roundedNumber)
            .toFixed(fixed || 2)
            .toString()
        : roundedNumber

    return toNumber(fixedNumber) >= 0
      ? `${prefix ? `${prefix} ` : ''}${displayCommaNumber(
          Big(fixedNumber).toString(),
          fixed
        )}`
      : `(${prefix ? `${prefix} ` : ''}${displayCommaNumber(
          Big(Math.abs(toNumber(fixedNumber))).toString(),
          fixed
        )})`
  }
  // Non numeric value will return itself
  return number
}

export default displayPrice
